import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Modal from '@cloudscape-design/components/modal';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import Textarea from '@cloudscape-design/components/textarea';
import Tabs from '@cloudscape-design/components/tabs';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
	brandLicensesAddModalStore,
	playerBanAddModalStore,
	playerHidePaywayAddModalStore,
} from "../stores/playerHidePaywayAddModal";
import ColumnLayout from "@cloudscape-design/components/column-layout";
import { Container } from "react-bootstrap";
import Select from "@cloudscape-design/components/select";
import DatePicker from "@cloudscape-design/components/date-picker";

class PlayerHidePaywayAddModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		}
	}


	resetFormFields = () => {
		const { setPlayerHidePaywayAddModal, playerHidePaywayAddModal } = this.props;
		setPlayerHidePaywayAddModal({
			...playerHidePaywayAddModal,
			show: false,
			loaded: false,
			uid: false,
			group: "",
			date: false,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateFormField = (key, value) => {
		const { playerHidePaywayAddModal, setPlayerHidePaywayAddModal } = this.props;
		const updatedState = cloneDeep(playerHidePaywayAddModal);
		updatedState[key] = value;
		setPlayerHidePaywayAddModal(updatedState);
	};

	addPlayerBan = async () => {
		const { playerHidePaywayAddModal, Interface } = this.props;


		try {
			const body = {
				...playerHidePaywayAddModal,
				banType: playerHidePaywayAddModal?.banType?.value
			};

			this.setState({
				loading: true,
			});

			const result = await Interface.request('set', {
				class: 'data',
				module: 'playerHidePayway',
				method: 'add',
			}, body);

			Interface.addNoty('Success', 'Player hide payway added successfully');
			Interface.loadPlayerHidePayway();
			this.resetFormFields();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		} finally {
			this.setState({
				loading: false,
			});
		}
	};

	render() {
		const { playerHidePaywayAddModal, setPlayerHidePaywayAddModal } = this.props;

		return (
			<Modal
				visible={playerHidePaywayAddModal.show}
				size="medium"
				onDismiss={() => setPlayerHidePaywayAddModal({ ...playerHidePaywayAddModal, show: false })}
				header="Add Player hide payway"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetFormFields}>
								Cancel
							</Button>
							<Button disabled={this.state.loading} loading={this.state.loading} variant="primary" onClick={this.addPlayerBan}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Container>
					<SpaceBetween direction="vertical" size="m">
						<FormField
							label="Uid"
							description="User uid"
							stretch
						>
							<Input
								type="number"
								value={playerHidePaywayAddModal.uid}
								onChange={({ detail }) =>
									this.updateFormField("uid", detail.value)
								}
								placeholder="1"
								inputMode="numeric"
							/>
						</FormField>

						<FormField
							label="Group Required"
							description="Group hidden"
							stretch
						>
							<Input
								type="text"
								value={playerHidePaywayAddModal.group}
								onChange={({ detail }) =>
									this.updateFormField(
										"group",
										detail.value === ""
											? ""
											: detail.value
									)
								}
								placeholder="group"
								inputMode="text"
							/>
						</FormField>
						<FormField label="Select ban type"
											 stretch>
							<Select
								filteringType="auto"
								placeholder="Ban type"
								selectedOption={playerHidePaywayAddModal.banType}
								onChange={({ detail }) => this.updateFormField("banType", detail.selectedOption)}
								options={[{ value: "forbidden", label: "Forbidden" }, { value: "date", label: "Date" }]}
								stretch
							/>
						</FormField>
						{playerHidePaywayAddModal.banType?.value === "date" && <FormField
							label="Till"
							description="Ban till"
							stretch
						>
							<DatePicker
								onChange={({ detail }) => this.updateFormField("date", detail.value)}
								value={playerHidePaywayAddModal.date}
								openCalendarAriaLabel={selectedDate =>
									"Choose certificate expiry date" +
									(selectedDate
										? `, selected date is ${selectedDate}`
										: "")
								}
								placeholder="YYYY/MM/DD"
								nextMonthAriaLabel={""} previousMonthAriaLabel={""} todayAriaLabel={""}/>
						</FormField>}

					</SpaceBetween>
				</Container>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerHidePaywayAddModal = useRecoilValue(playerHidePaywayAddModalStore);
		const setPlayerHidePaywayAddModal = useSetRecoilState(playerHidePaywayAddModalStore);

		return (
			<Component
				{...props}
				setPlayerHidePaywayAddModal={setPlayerHidePaywayAddModal}
				playerHidePaywayAddModal={playerHidePaywayAddModal}
			/>
		);
	};
}

export default withRecoil(PlayerHidePaywayAddModal);